import React from 'react';

function SectionTitle({ label, title, accent, end, center }) {
  return (
    <div className={center ? 'section-head center reveal' : 'section-head reveal'}>
      {label ? <span className="s-label">{label}</span> : null}
      <h2 className="s-title">
        {title} {accent ? <em>{accent}</em> : null} {end || ''}
      </h2>
    </div>
  );
}

export default SectionTitle;